import { Platform } from 'quasar';
import { boot } from 'quasar/wrappers';
import { Keyboard } from 'src/../src-capacitor/node_modules/@capacitor/keyboard';
import { EVENTS } from 'src/composables/const';
import { useDeviceStore } from 'src/store/deviceStore';

export default boot(({}) => {
  if (Platform.is.capacitor) {
    const device = useDeviceStore();

    void Keyboard.addListener(EVENTS.KEYBOARD_WILL_SHOW, () => {
      device.showKeyboard();
    });

    void Keyboard.addListener(EVENTS.KEYBOARD_WILL_HIDE, () => {
      device.hideKeyboard();
    });
  }
});
